export function getImageSize(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = (e) => {
            const image = new window.Image();
            image.onerror = reject;
            image.onload = () => {
                const width = image.naturalWidth;
                const height = image.naturalHeight;
                resolve({ width, height, image });
            };
            image.src = e.target.result;
        };
        reader.readAsDataURL(file);
    });
}

export function getGcd(width, height) {
    return height == 0 ? width : getGcd(height, width % height);
}

export function getAspectRatio(width, height) {
    const gcd = getGcd(width, height);
    return width / gcd + ':' + height / gcd;
}
